import { useMemo } from "react";

import createStore from "@Stores/base-factories"
import { hookCustomFieldsList, hookOrganizationUserList, hookPageList } from "@Stores/base-factories/store-list";
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const usePathFactory = ({ fetch, siteSelected: { id: siteId } }) => useMemo(() => ({
  updatePathPagesRules: async data => {
    const result = await fetch({
      method: 'put',
      url: `pathpage/${data.id}/rules`,
      data,
      params: { siteId },
    });

    if (!result) {
      throw Error()
    }
  },
  getSlotVersions: async ({ slotId, data }) => {
    const result = await fetch({
      method: 'get',
      url: `slot/${slotId}/versions`,
      params: {
        siteId,
        ...data,
        options: {
          sortField: "id",
          sortOrder: "asc",
          ...data?.options,
        },
      },
    });

    if (!result) {
      throw Error()
    }

    return result;
  },
}), [fetch, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('path')
  .extendHookCollectionsFactory('paths')
  .extend(hookPageList())
  .extend(hookCustomFieldsList())
  .extend(usePathFactory)
  .extend(hookOrganizationUserList('users'))
  .factory()

export {
  Provider as PathProvider,
  useStore as usePathStore,
}
